import axios from 'axios';

// 創建一個 axios 實例
const http = axios.create({
  baseURL: process.env.VUE_APP_PUBLIC_PATH, // 使用你的 base URL
});

// 添加一個請求攔截器
http.interceptors.request.use(
  config => {
    // 根據請求的路徑判斷是否使用 driverToken 或 adminToken
    if (config.url.includes('/admin')) {
      const adminToken = localStorage.getItem('adminToken');
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      }
    } else {
      const driverToken = localStorage.getItem('driverToken');
      if (driverToken) {
        config.headers.Authorization = `Bearer ${driverToken}`;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 添加一個響應攔截器
http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

// 導出 axios 實例
export function useHttp() {
  return http;
}
